import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { HttpStatusCode, isAxiosError } from 'axios';
import { BackButton, BackWrapper, Button, CloseButton, ContentActions, ListModalDescription, MessageDescription, MessageTitle, MessageTitleWrapper, ModalContent, ModalDescription, ModalDescriptionWrapper, ModalTitle, ModalTitleIcon, ModalTitleWrapper, NextButton, SendedEmailMessageWrapper } from './styled';
import { modalStore, roomModalStore } from '@/shared/model/modal';
import { ArrowBackIcon } from '@/shared/assets/icons';
import { MetricsService } from '@/shared/api/services/MetricsService';
import { MetricType } from '@/shared/types/metrics';
import AuthService, { ReminderFailReasons } from '@/shared/api/services/AuthService';
import { refresh, sendedSMS } from '@/shared/assets/images';
import { userStore } from '@/shared/model/user';
import { ErrorText } from '@/widgets/pre-login/ui/styled';
const InnerBestDesktopModal = () => {
    const { user: { email }, } = userStore;
    const [isOpenSwitchToDesktop, setIsOpenSwitcToDesktop] = useState(false);
    const [isEmailSend, setIsEmailSend] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleClose = () => {
        modalStore.close();
        roomModalStore.close();
    };
    const handlOpenSwitchDesktop = () => {
        setIsOpenSwitcToDesktop(true);
    };
    const handleBackCLick = () => {
        setIsOpenSwitcToDesktop(false);
    };
    const handleSendink = useCallback(async () => {
        MetricsService.sendMetrics({
            type: MetricType.SEND_EMAIL_REMAINDER_CLICK,
            meta: {
                email,
            },
        });
        setError('');
        setLoading(true);
        const response = await AuthService.sendReminder({ email });
        setLoading(false);
        if (response && !isAxiosError(response)) {
            const { data: { success }, } = response;
            if (success) {
                setIsEmailSend(true);
                return;
            }
        }
        if (isAxiosError(response)) {
            const { response: apiResponse, request: { status }, } = response;
            if (status === HttpStatusCode.TooManyRequests) {
                setError('System error');
                return;
            }
            const { data: apiResponseData } = apiResponse;
            const { message } = apiResponseData ?? {};
            if (message === ReminderFailReasons.DAY_LIMIT_EXCEEDED) {
                setError('Resend limit reached. Try again later.');
                return;
            }
        }
        setError('Something went wrong. Try again later.');
    }, [email]);
    return (_jsx(ModalContent, { children: isOpenSwitchToDesktop ? _jsxs(_Fragment, { children: [_jsxs(ModalTitleWrapper, { children: [_jsx(ModalTitleIcon, { src: refresh }), _jsx(ModalTitle, { children: "Best on Desktop!" })] }), _jsxs(ModalDescriptionWrapper, { children: [_jsx(ModalDescription, { children: "For the best experience, use Realush on a desktop." }), _jsxs(ListModalDescription, { children: ["Open ", _jsx("span", { children: "www.realush.com" }), " on your desktop then sign in."] }), _jsx(ModalDescription, { children: _jsx("strong", { children: "OR" }) }), _jsx(ListModalDescription, { children: "Send yourself an email with a quick access link for later:" })] }), !isEmailSend ? (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: handleSendink, fontWeight: 600, fullWidth: true, loading: loading, height: 48, children: "Send Link" }), error && _jsx(ErrorText, { children: error }), _jsx(BackWrapper, { children: _jsxs(BackButton, { onClick: handleBackCLick, children: [_jsx(ArrowBackIcon, {}), " Back"] }) })] })) : (_jsxs(_Fragment, { children: [_jsxs(SendedEmailMessageWrapper, { children: [_jsxs(MessageTitleWrapper, { children: [_jsx(ModalTitleIcon, { src: sendedSMS }), _jsx(MessageTitle, { children: "Email sent!" })] }), _jsx(MessageDescription, { children: "Check your inbox and join the action!" })] }), _jsx(NextButton, { width: "150px", onClick: handleClose, children: "Got it!" })] }))] }) :
            _jsxs(_Fragment, { children: [_jsx(ModalTitle, { children: "Best on Desktop!" }), _jsx(ModalDescription, { children: "For the best experience, we recommend using a desktop or a tablet in landscape mode. You can continue on mobile, but some features may be limited." }), _jsxs(ContentActions, { children: [_jsx(CloseButton, { onClick: handleClose, children: "Continue" }), _jsx(NextButton, { onClick: handlOpenSwitchDesktop, children: "Use Desktop" })] })] }) }));
};
export const BestDesktopModal = memo(InnerBestDesktopModal);
